<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0">
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Seemless Game</h3>
                    <div class="mb-3">
                        <label for="title" class="form-label">Game Title <em>*</em></label>
                        <input type="text" class="form-control" id="title" name="title" #title="ngModel"
                            [(ngModel)]="data.title" required autocomplete="off">
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Game Title is required</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="provider" class="form-label">API Provider <em>*</em></label>
                        <ng-select name="provider" #provider="ngModel" [(ngModel)]="data.api_id" required
                            (change)="onProviderChange()" [items]="providers" bindValue="id"
                            bindLabel="name"></ng-select>
                    </div>
                    <div class="mb-3">
                        <label for="logo" class="form-label">Image</label>
                        <app-image-uploader [type]="'single'" #imageUploader (deleteEvent)="removeImage()"
                            (uploadEvent)="upload($event)"></app-image-uploader>
                    </div>

                    <div class="row" *ngIf="provider_categories && provider_categories.length > 0">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="type" class="form-label">Provider Category <em>*</em></label>
                                <ng-select id="type" name="type" [(ngModel)]="data.type" [items]="provider_categories"
                                    bindValue="id" bindLabel="title" (change)="onProviderCategoryChange()"></ng-select>
                            </div>
                        </div>
                    </div>

                    <!-- Direct entry: launch one specific game directly (AWC-style), instead of
                         showing the player a grid of every game in the provider category.
                         Shown as soon as a provider with categories is picked so it can't be
                         missed; the game picker then waits for a category to be selected. -->
                    <div class="mb-3" *ngIf="provider_categories && provider_categories.length > 0">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="direct_entry" name="direct_entry"
                                   [ngModel]="direct_entry"
                                   (ngModelChange)="onDirectEntryChange($event)" />
                            <label class="form-check-label" for="direct_entry">
                                Direct entry / 直接进入游戏
                            </label>
                            <p class="mb-0 small text-muted">
                                If enabled, selecting this tile takes the player straight into one chosen game,
                                skipping the in-game game list. Leave off to show all games in the category.
                            </p>
                        </div>
                    </div>

                    <!-- Game picker: needs a Provider Category so we know which catalog to fetch. -->
                    <div class="mb-3" *ngIf="direct_entry && data.type">
                        <label for="direct_game_id" class="form-label">Direct Game <em>*</em></label>
                        <ng-select id="direct_game_id" name="direct_game_id" [(ngModel)]="direct_game_id"
                            [items]="direct_games" bindValue="id" bindLabel="name" [loading]="direct_loading"
                            [required]="direct_entry"
                            placeholder="Select the game to launch directly"></ng-select>
                        <div *ngIf="direct_loading" class="small text-muted">Loading games from provider…</div>
                        <div *ngIf="!direct_loading && direct_error" class="small text-danger">{{ direct_error }}</div>
                    </div>
                    <div class="mb-3" *ngIf="direct_entry && !data.type">
                        <div class="small text-warning">Select a <strong>Provider Category</strong> above to load its games.</div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="category_id" class="form-label">Category <em>*</em></label>
                                <ng-select id="category_id" name="category_id" [(ngModel)]="data.category_id"
                                    [items]="categories" bindValue="id" bindLabel="title"></ng-select>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="sort" class="form-label">Sort</label>
                        <input type="number" class="form-control" id="sort" name="sort" #sort="ngModel"
                            [(ngModel)]="data.sort">
                    </div>

                    <div class="mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="event_only" name="event_only"
                                   [ngModel]="data.event_only == 1 || data.event_only === true"
                                   (ngModelChange)="data.event_only = $event ? 1 : 0" />
                            <label class="form-check-label" for="event_only">
                                Event-only game / 活动专用游戏
                            </label>
                            <p class="mb-0 small text-muted">
                                If enabled, players can only enter this game when they have an active promotion that covers it. Clicking the game without an active event shows a "this game is available only during an event" popup.
                            </p>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary">Update</button>
                </form>
            </div>
        </div>
    </div>
</div>